import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="home">
      <header className="hero-section">
        <h1>Welcome to Nagoya Investments</h1>
        <p className="hero-subtitle">A dynamic investment firm committed to fostering growth across diverse sectors.</p>
        <p className="hero-description">Our strategic investments span real estate, renewable energy, and commercial enterprises, driving innovation and delivering value nationwide.</p>
        <div className="hero-buttons">
          <Link to="/contact" className="cta-button">Get in Touch</Link>
          <Link to="/investment-strategy" className="cta-button secondary">Learn More</Link>
        </div>
      </header>
      
      <section className="investment-sectors">
        <h2>Our Investment Sectors</h2>
        <div className="sectors-grid">
          <div className="sector-card">
            <div className="sector-icon">🏢</div>
            <h3>Real Estate</h3>
            <p>Strategic property investments across prime locations</p>
          </div>
          <div className="sector-card">
            <div className="sector-icon">🌱</div>
            <h3>Renewable Energy</h3>
            <p>Sustainable energy solutions for a better future</p>
          </div>
          <div className="sector-card">
            <div className="sector-icon">💼</div>
            <h3>Commercial Enterprises</h3>
            <p>Supporting innovative businesses and startups</p>
          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <h2>Why Choose Nagoya Investments</h2>
        <div className="features">
          <div className="feature">
            <h3>Global Expertise</h3>
            <p>Access to international markets and opportunities</p>
          </div>
          <div className="feature">
            <h3>Strategic Approach</h3>
            <p>Data-driven investment decisions</p>
          </div>
          <div className="feature">
            <h3>Risk Management</h3>
            <p>Comprehensive risk assessment and mitigation</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 